import React, { ReactNode } from 'react'
import { Box, Icon, Typography } from '@dasa-health/components-react'
import { SystemBoldChevronup, SystemBoldChevrondown } from '@dasa-health/icons'
import { Collapse, CollapseHeader, CollapseContent } from './styles'
import { isSafariDesktop } from '@nsw-paginas-deslogadas/utils'

interface GenericCollapseProps {
    className?: string
    children: ReactNode
    isOpen?: boolean
    title: string
    showDivider?: boolean
    renderLPV2?: boolean
}

export const GenericCollapse: React.FC<GenericCollapseProps> = ({
    isOpen = false,
    title,
    children,
    showDivider = true,
    renderLPV2,
}) => {
    const [collapseHeight, setCollapseHeight] = React.useState(0)
    const [isExpanded, setIsExpanded] = React.useState(isOpen)
    const collapseRef = React.useRef<HTMLDivElement>(null)

    const updateSize = React.useCallback(() => {
        if (collapseRef && collapseRef.current) {
            const { childNodes } = collapseRef?.current
            let totalHeight = 0

            childNodes.forEach((cn: HTMLElement) => {
                totalHeight += cn.offsetHeight
            })

            setCollapseHeight(totalHeight)
        }
    }, [])

    React.useLayoutEffect(() => {
        window.addEventListener('resize', updateSize)

        updateSize()

        return () => window.removeEventListener('resize', updateSize)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [collapseRef?.current])

    return (
        <Collapse aria-expanded={isExpanded} aria-label="collapse" data-testid="generic-collapse" showDivider={showDivider}>
            <CollapseHeader onClick={() => setIsExpanded(!isExpanded)}>
                <Typography
                    aria-label={`titulo-collapse-${title}`}
                    as="h3"
                    data-testid="generic-collapse-title"
                    style={{ fontWeight: renderLPV2 ? 700 : 500 }}
                >
                    {title}
                </Typography>
                <Icon>{isExpanded ? <SystemBoldChevronup /> : <SystemBoldChevrondown />}</Icon>
            </CollapseHeader>

            <CollapseContent
                aria-label={`conteudo-do-${title}`}
                isSafariDesktop={isSafariDesktop()}
                ref={collapseRef}
                style={{ height: isExpanded ? collapseHeight : 0 }}
            >
                <Box>{children}</Box>
            </CollapseContent>
        </Collapse>
    )
}

export default GenericCollapse
